import React from 'react';

const Hr = () => {
  return (
    <hr className="ds-hr"></hr>
  )
}

export default Hr;
